export const SOFT_SKILLS_RULES = {
  "base_score" : "40",
  "groups" : [ 
      {
          "min_total" : "20",
          "max_total" : "180",
          "categories" : [ 
              "Assertive", 
              "Trusting"
          ]
      }, 
      {
          "min_total" : "30",
          "max_total" : "170",
          "categories" : [ 
              "Assertive", 
              "Emotional"
          ]
      }, 
      {
          "min_total" : "25",
          "max_total" : "175",
          "categories" : [ 
              "Flexible", 
              "Detail-oriented"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Flexible", 
              "Genuine"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Flexible", 
              "Competitive"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Flexible", 
              "Conformist"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Detail-oriented", 
              "Emotional"
          ]
      }, 
      {
          "min_total" : "25",
          "max_total" : "175",
          "categories" : [ 
              "Trusting", 
              "Emotional"
          ]
      }, 
      {
          "min_total" : "40",
          "max_total" : "160",
          "categories" : [ 
              "Trusting", 
              "Competitive"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Trusting", 
              "Practical"
          ]
      }, 
      {
          "min_total" : "30",
          "max_total" : "170",
          "categories" : [ 
              "Emotional", 
              "Competitive"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Emotional", 
              "Optimistic"
          ]
      }, 
      {
          "min_total" : "30",
          "max_total" : "170",
          "categories" : [ 
              "Emotional", 
              "Conformist"
          ]
      }, 
      {
          "min_total" : "30",
          "max_total" : "170",
          "categories" : [ 
              "Sociable", 
              "Genuine"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Sociable", 
              "Competitive"
          ]
      }, 
      {
          "min_total" : "10",
          "max_total" : "190",
          "categories" : [ 
              "Sociable", 
              "Practical"
          ]
      }, 
      {
          "min_total" : "20",
          "max_total" : "180",
          "categories" : [ 
              "Optimistic", 
              "Practical"
          ]
      }
  ],
  "mechanism_start_on_click" : "0",
  "parent" : "",
  "points" : {
    "Assertive": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0,
          "Flexible": 0,
          "Detail-oriented": 0,
          "Trusting": -0.2,
          "Emotional": -0.3,
          "Sociable": 0,
          "Genuine": 0.2,
          "Competitive": 0.2,
          "Optimistic": 0.3,
          "Practical": 0.2,
          "Conformist": 0
        },
        "down": {
          "Assertive": 0,
          "Flexible": 0,
          "Detail-oriented": 0,
          "Trusting": 0.2,
          "Emotional": 0.3,
          "Sociable": 0,
          "Genuine": -0.2,
          "Competitive": -0.2,
          "Optimistic": -0.3,
          "Practical": -0.2,
          "Conformist": 0
        }
      },
      "tooltip": "Proficient communicator who confidently articulates thoughts and needs, setting boundaries with respect for others."
    },
    "Flexible": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0,
          "Flexible": 0,
          "Detail-oriented": -0.25,
          "Trusting": 0.25,
          "Emotional": 0,
          "Sociable": 0,
          "Genuine": -0.1,
          "Competitive": -0.1,
          "Optimistic": 0.3,
          "Practical": 0.1,
          "Conformist": -0.1
        },
        "down": {
          "Assertive": 0,
          "Flexible": 0,
          "Detail-oriented": 0.25,
          "Trusting": -0.25,
          "Emotional": 0,
          "Sociable": 0,
          "Genuine": 0.1,
          "Competitive": 0.1,
          "Optimistic": -0.3,
          "Practical": -0.1,
          "Conformist": 0.1
        }
      },
      "tooltip": "Adaptable professional with openness to change, demonstrating resilience and versatility in diverse situations."
    },
    "Detail-oriented": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0,
          "Flexible": -0.25,
          "Detail-oriented": 0,
          "Trusting": 0,
          "Emotional": -0.1,
          "Sociable": 0,
          "Genuine": 0.1,
          "Competitive": 0.1,
          "Optimistic": 0.1,
          "Practical": 0.4,
          "Conformist": 0.4
        },
        "down" : {
          "Assertive": 0,
          "Flexible": 0.25,
          "Detail-oriented": 0,
          "Trusting": 0,
          "Emotional": 0.1,
          "Sociable": 0,
          "Genuine": -0.1,
          "Competitive": -0.1,
          "Optimistic": -0.1,
          "Practical": -0.4,
          "Conformist": -0.4
        }
      },
      "tooltip": "Meticulous individual with a focus on precision and accuracy, ensuring meticulous attention to detail."
    },
    "Trusting": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": -0.2,
          "Flexible": 0.25,
          "Detail-oriented": 0,
          "Trusting": 0,
          "Emotional": -0.25,
          "Sociable": 0.25,
          "Genuine": 0,
          "Competitive": -0.4,
          "Optimistic": 0.4,
          "Practical": -0.1,
          "Conformist": 0.1
        },
        "down": {
          "Assertive": 0.2,
          "Flexible": -0.25,
          "Detail-oriented": 0,
          "Trusting": 0,
          "Emotional": 0.25,
          "Sociable": -0.25,
          "Genuine": 0,
          "Competitive": 0.4,
          "Optimistic": -0.4,
          "Practical": 0.1,
          "Conformist": -0.1
        }
      },
      "tooltip" : "Reliable and dependable professional known for integrity, consistency, and a track record of keeping commitments."
    },
    "Emotional": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": -0.3,
          "Flexible": 0,
          "Detail-oriented": -0.1,
          "Trusting": -0.25,
          "Emotional": 0,
          "Sociable": 0.2,
          "Genuine": 0.2,
          "Competitive": -0.3,
          "Optimistic": -0.1,
          "Practical": 0,
          "Conformist": -0.3
        },
        "down": {
          "Assertive": 0.3,
          "Flexible": 0,
          "Detail-oriented": 0.1,
          "Trusting": 0.25,
          "Emotional": 0,
          "Sociable": -0.2,
          "Genuine": -0.2,
          "Competitive": 0.3,
          "Optimistic": 0.1,
          "Practical": 0,
          "Conformist": 0.3
        }
      },
      "tooltip": "Emotionally intelligent individual adept at expressing and navigating feelings, fostering deep connections."
    },
    "Sociable": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0,
          "Flexible": 0,
          "Detail-oriented": 0,
          "Trusting": 0.25,
          "Emotional": 0.2,
          "Sociable": 0,
          "Genuine": -0.3,
          "Competitive": -0.1,
          "Optimistic": 0,
          "Practical": -0.1,
          "Conformist": 0
        },
        "down": {
          "Assertive": 0,
          "Flexible": 0,
          "Detail-oriented": 0,
          "Trusting": -0.25,
          "Emotional": -0.2,
          "Sociable": 0,
          "Genuine": 0.3,
          "Competitive": 0.1,
          "Optimistic": 0,
          "Practical": 0.1,
          "Conformist": 0
        }
      },
      "tooltip": "Outgoing and amiable professional who excels in interpersonal interactions and social engagements."
    },
    "Genuine": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0.2,
          "Flexible": -0.1,
          "Detail-oriented": 0.1,
          "Trusting": 0,
          "Emotional": 0.2,
          "Sociable": -0.3,
          "Genuine": 0,
          "Competitive": 0,
          "Optimistic": 0,
          "Practical": 0.2,
          "Conformist": 0
        },
        "down": {
          "Assertive": -0.2,
          "Flexible": 0.1,
          "Detail-oriented": -0.1,
          "Trusting": 0,
          "Emotional": -0.2,
          "Sociable": 0.3,
          "Genuine": 0,
          "Competitive": 0,
          "Optimistic": 0,
          "Practical": -0.2,
          "Conformist": 0
        }
      },
      "tooltip": "Authentic and sincere individual, consistently transparent and truthful in both actions and communications."
    },
    "Competitive": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0.2,
          "Flexible": -0.1,
          "Detail-oriented": 0.1,
          "Trusting": -0.4,
          "Emotional": -0.3,
          "Sociable": -0.1,
          "Genuine": 0,
          "Competitive": 0,
          "Optimistic": 0,
          "Practical": 0,
          "Conformist": 0.1
        },
        "down": {
          "Assertive": -0.2,
          "Flexible": 0.1,
          "Detail-oriented": -0.1,
          "Trusting": 0.4,
          "Emotional": 0.3,
          "Sociable": 0.1,
          "Genuine": 0,
          "Competitive": 0,
          "Optimistic": 0,
          "Practical": 0,
          "Conformist": -0.1
        }
      },
      "tooltip": "Results-driven professional who thrives on challenges, actively seeking opportunities for excellence in a competitive landscape."
    },
    "Optimistic": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0.3,
          "Flexible": 0.3,
          "Detail-oriented": 0.1,
          "Trusting": 0.4,
          "Emotional": -0.1,
          "Sociable": 0,
          "Genuine": 0,
          "Competitive": 0,
          "Optimistic": 0,
          "Practical": -0.2,
          "Conformist": 0
        },
        "down": {
          "Assertive": -0.3,
          "Flexible": -0.3,
          "Detail-oriented": -0.1,
          "Trusting": -0.4,
          "Emotional": 0.1,
          "Sociable": 0,
          "Genuine": 0,
          "Competitive": 0,
          "Optimistic": 0,
          "Practical": 0.2,
          "Conformist": 0
        }
      },
      "tooltip": "Positive-minded individual with an optimistic outlook, approaching challenges as opportunities for growth."
    },
    "Practical": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0.2,
          "Flexible": 0.1,
          "Detail-oriented": 0.4,
          "Trusting": -0.1,
          "Emotional": 0,
          "Sociable": -0.1,
          "Genuine": 0.2,
          "Competitive": 0,
          "Optimistic": -0.2,
          "Practical": 0,
          "Conformist": 0
        },
        "down": {
          "Assertive": -0.2,
          "Flexible": -0.1,
          "Detail-oriented": -0.4,
          "Trusting": 0.1,
          "Emotional": 0,
          "Sociable": 0.1,
          "Genuine": -0.2,
          "Competitive": 0,
          "Optimistic": 0.2,
          "Practical": 0,
          "Conformist": 0
        }
      },
      "tooltip": "Realistic and pragmatic professional, addressing challenges with a grounded, common-sense approach."
    },
    "Conformist": {
      "score": 50,
      "tradeoffs": {
        "up": {
          "Assertive": 0,
          "Flexible": -0.1,
          "Detail-oriented": 0.4,
          "Trusting": 0.1,
          "Emotional": -0.3,
          "Sociable": 0,
          "Genuine": 0,
          "Competitive": 0.1,
          "Optimistic": 0,
          "Practical": 0,
          "Conformist": 0
        },
        "down": {
          "Assertive": 0,
          "Flexible": 0.1,
          "Detail-oriented": -0.4,
          "Trusting": 0.1,
          "Emotional": 0.3,
          "Sociable": 0,
          "Genuine": 0,
          "Competitive": -0.1,
          "Optimistic": 0,
          "Practical": 0,
          "Conformist": 0
        }
      },
      "tooltip": "Individual who adheres to established norms, rules, and societal expectations, valuing conformity within cultural contexts."
    }
  }
}